import { Injectable, inject } from '@angular/core';
import { AppCheck, getToken } from '@angular/fire/app-check';

@Injectable({
  providedIn: 'root'
})
export class AppCheckService {
  private appCheck = inject(AppCheck);

  async getAppCheckToken(): Promise<string | null> {
    try {
      const tokenResult = await getToken(this.appCheck, false);
      return tokenResult.token;
    } catch (error) {
      console.error('Failed to get App Check token:', error);
      return null;
    }
  }
}
